
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1kxh5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cd69c6b7bfd6e6e3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $cd69c6b7bfd6e6e3$export$2e2bcd8739ae039 = {
    'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Modifiche terminate',
    'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Apporta modifiche',
    'editor-common-extensibility.macro.button.configure': 'Configura {macroName}',
    'fablric.editor.viewAllInserts': 'Visualizza tutti gli inserimenti',
    'fabric.editor.action': "Attivit\xe0",
    'fabric.editor.action.description': 'Crea e assegna elementi di azione',
    'fabric.editor.addAltText': 'Testo alternativo',
    'fabric.editor.addColumnLeft': 'Aggiungi colonna a sinistra',
    'fabric.editor.addColumnRight': 'Aggiungi colonna a destra',
    'fabric.editor.addCommentOnMedia': 'Aggiungi un commento',
    'fabric.editor.addImageBorder': 'Aggiungi bordo',
    'fabric.editor.addLoomVideo': 'Registra un video Loom',
    'fabric.editor.addLoomVideoComment': 'Registra un commento al video Loom',
    'fabric.editor.addMediaFiles': "Aggiungi un'immagine, un video o un file",
    'fabric.editor.addRowAbove': 'Aggiungi riga sopra',
    'fabric.editor.addRowBelow': 'Aggiungi riga sotto',
    'fabric.editor.addUpdatedAltText': 'Aggiungi testo alternativo',
    'fabric.editor.ai.ai-panels.actionItemsPageDescription': 'Usa Atlassian Intelligence per trovare gli elementi di azione e visualizzarli in un riquadro',
    'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Riquadro degli elementi di azione (Beta)',
    'fabric.editor.ai.ai-panels.summarizePageDescription': 'Usa Atlassian Intelligence per riassumere questa pagina e visualizzarla in un riquadro',
    'fabric.editor.ai.ai-panels.summarizePageTitle': 'Riquadro di riepilogo della pagina (Beta)',
    'fabric.editor.ai.ai-smart-button.context.reference': 'Contenuto selezionato',
    'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription': "Genera contenuti da inserire nell'aggiornamento",
    'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': "Riassume il contenuto dell'aggiornamento",
    'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Genera',
    'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Chiedi ad Atlassian Intelligence',
    'fabric.editor.ai.config.item.action.edit': 'Modifica',
    'fabric.editor.ai.config.item.action.insert': 'Inserisci',
    'fabric.editor.ai.config.item.action.insertAtTop': 'Inserisci sopra',
    'fabric.editor.ai.config.item.action.insertBelow': 'Inserisci sotto',
    'fabric.editor.ai.config.item.action.replace': 'Sostituisci',
    'fabric.editor.ai.config.item.action.replaceTitle': 'Sostituisci il titolo',
    'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip': "Il titolo non pu\xf2 superare {maxLength} caratteri",
    'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Apri nella chat',
    'fabric.editor.ai.config.item.agent.title': 'Agente Rovo di Atlassian Intelligence',
    'fabric.editor.ai.config.item.atlas-shorten-update.description': "Abbrevia il contenuto per renderlo pi\xf9 conciso",
    'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Abbrevia aggiornamento',
    'fabric.editor.ai.config.item.bb.pr.description.description': 'Crea una descrizione della pull request con un riepilogo delle modifiche',
    'fabric.editor.ai.config.item.bb.pr.description.title': 'Crea la descrizione della pull request',
    'fabric.editor.ai.config.item.brainstorm.description': 'Genera un elenco di idee per un argomento da te indicato',
    'fabric.editor.ai.config.item.brainstorm.promptHint': "Indicami l'argomento...",
    'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorming',
    'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorming',
    'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Cambia il tono del contenuto rendendolo informale',
    'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Informale',
    'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Informale',
    'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Cambia il tono in informale',
    'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Cambia il tono del contenuto rendendolo istruttivo',
    'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Istruttivo',
    'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Istruttivo',
    'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Cambia il tono in istruttivo',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Cambia il tono del contenuto rendendolo empatico',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatico',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatico',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Cambia il tono in empatico',
    'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Cambia il tono in...',
    'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Cambia il tono del contenuto rendendolo neutro',
    'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutro',
    'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutro',
    'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Cambia il tono in neutro',
    'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Cambia il tono del contenuto rendendolo professionale',
    'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionale',
    'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionale',
    'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Cambia il tono in professionale',
    'fabric.editor.ai.config.item.convertToBulletList.description': 'Riformatta il contenuto in un elenco puntato',
    'fabric.editor.ai.config.item.convertToBulletList.title': 'Converti in elenco puntato',
    'fabric.editor.ai.config.item.convertToTable.description': 'Riformatta il contenuto in una tabella con intestazioni',
    'fabric.editor.ai.config.item.convertToTable.title': 'Converti in tabella',
    'fabric.editor.ai.config.item.draftReply.description': 'Elabora una risposta in base a ticket simili a quello su cui stai lavorando',
    'fabric.editor.ai.config.item.draftReply.title': 'Bozza di risposta',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Corregge errori di ortografia e grammatica',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Ortografia e grammatica',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Correggi ortografia e grammatica',
    'fabric.editor.ai.config.item.enhance.improveWriting.description': 'Ottimizza chiarezza, struttura e tono per migliorare coinvolgimento e comprensione',
    'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Migliora lo stile',
    'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Migliora lo stile',
    'fabric.editor.ai.config.item.findActionItems.description': 'Trova gli elementi di azione nei contenuti forniti',
    'fabric.editor.ai.config.item.findActionItems.title': 'Trova elementi di azione',
    'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint': "Seleziona di seguito (la scrittura libera dei prompt \xe8 disabilitata in Elevate in questa fase)",
    'fabric.editor.ai.config.item.generateContent.promptHint': 'Scrivi con AI o seleziona qui sotto',
    'fabric.editor.ai.config.item.improveDescription.default.description': 'Ristruttura la descrizione del ticket in base al tipo di ticket',
    'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Migliora descrizione',
    'fabric.editor.ai.config.item.makeLonger.description': 'Espande il contenuto in base al contesto fornito',
    'fabric.editor.ai.config.item.makeLonger.title': 'Allunga',
    'fabric.editor.ai.config.item.range.agent.description': 'Nessuna descrizione',
    'fabric.editor.ai.config.item.range.agent.prompt.hint': "Chiedi all'agente di scrivere qualcosa o scegli tra le seguenti opzioni",
    'fabric.editor.ai.config.item.rephrase.description': 'Crea un suggerimento per riscrivere le frasi',
    'fabric.editor.ai.config.item.rephrase.title': 'Riformula',
    'fabric.editor.ai.config.item.shorten.description': "Abbrevia il contenuto per renderlo pi\xf9 conciso",
    'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Abbrevia',
    'fabric.editor.ai.config.item.shorten.title': 'Abbrevia',
    'fabric.editor.ai.config.item.suggest.description': 'Suggerisce un titolo per i contenuti forniti',
    'fabric.editor.ai.config.item.suggest.title': 'Suggerisci un titolo',
    'fabric.editor.ai.config.item.summarize.description': 'Crea un riepilogo del testo su cui stai lavorando, evidenziando i punti chiave',
    'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Riepiloga il contenuto',
    'fabric.editor.ai.config.item.summarize.title': 'Riepiloga il contenuto',
    'fabric.editor.ai.config.item.translate.czech': 'Ceco',
    'fabric.editor.ai.config.item.translate.danish': 'Danese',
    'fabric.editor.ai.config.item.translate.dutch': 'Olandese',
    'fabric.editor.ai.config.item.translate.english': 'Inglese',
    'fabric.editor.ai.config.item.translate.finnish': 'Finlandese',
    'fabric.editor.ai.config.item.translate.french': 'Francese',
    'fabric.editor.ai.config.item.translate.german': 'Tedesco',
    'fabric.editor.ai.config.item.translate.hungarian': 'Ungherese',
    'fabric.editor.ai.config.item.translate.italian': 'Italiano',
    'fabric.editor.ai.config.item.translate.japanese': 'Giapponese',
    'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Traduci',
    'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Traduci in...',
    'fabric.editor.ai.config.item.translate.norwegian': 'Norvegese',
    'fabric.editor.ai.config.item.translate.russian': 'Russo',
    'fabric.editor.ai.config.item.translate.spanish': 'Spagnolo',
    'fabric.editor.ai.config.item.translate.swedish': 'Svedese',
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.description': 'Traduce il testo su cui stai lavorando in cinese (semplificato)',
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Traduci in cinese (semplificato)',
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.description': 'Traduce il testo su cui stai lavorando in cinese (tradizionale)',
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Traduci in cinese (tradizionale)',
    'fabric.editor.ai.config.item.translateTo.czech.description': 'Traduce il testo su cui stai lavorando in ceco',
    'fabric.editor.ai.config.item.translateTo.czech.title': 'Traduci in ceco',
    'fabric.editor.ai.config.item.translateTo.danish.description': 'Traduce il testo su cui stai lavorando in danese',
    'fabric.editor.ai.config.item.translateTo.danish.title': 'Traduci in danese',
    'fabric.editor.ai.config.item.translateTo.dutch.description': 'Traduce il testo su cui stai lavorando in olandese',
    'fabric.editor.ai.config.item.translateTo.dutch.title': 'Traduci in olandese',
    'fabric.editor.ai.config.item.translateTo.english.description': 'Traduce il testo su cui stai lavorando in inglese',
    'fabric.editor.ai.config.item.translateTo.english.title': 'Traduci in inglese',
    'fabric.editor.ai.config.item.translateTo.finnish.description': 'Traduce il testo su cui stai lavorando in finlandese',
    'fabric.editor.ai.config.item.translateTo.finnish.title': 'Traduci in finlandese',
    'fabric.editor.ai.config.item.translateTo.french.description': 'Traduce il testo su cui stai lavorando in francese',
    'fabric.editor.ai.config.item.translateTo.french.title': 'Traduci in francese',
    'fabric.editor.ai.config.item.translateTo.german.description': 'Traduce il testo su cui stai lavorando in tedesco',
    'fabric.editor.ai.config.item.translateTo.german.title': 'Traduci in tedesco',
    'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Traduce il testo su cui stai lavorando in ungherese',
    'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Traduci in ungherese',
    'fabric.editor.ai.config.item.translateTo.italian.description': 'Traduce il testo su cui stai lavorando in italiano',
    'fabric.editor.ai.config.item.translateTo.italian.title': 'Traduci in italiano',
    'fabric.editor.ai.config.item.translateTo.japanese.description': 'Traduce il testo su cui stai lavorando in giapponese',
    'fabric.editor.ai.config.item.translateTo.japanese.title': 'Traduci in giapponese',
    'fabric.editor.ai.config.item.translateTo.korean.description': 'Traduce il testo su cui stai lavorando in coreano',
    'fabric.editor.ai.config.item.translateTo.korean.title': 'Traduci in coreano',
    'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Traduce il testo su cui stai lavorando in norvegese',
    'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Traduci in norvegese',
    'fabric.editor.ai.config.item.translateTo.polish.description': 'Traduce il testo su cui stai lavorando in polacco',
    'fabric.editor.ai.config.item.translateTo.polish.title': 'Traduci in polacco',
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description': 'Traduce il testo su cui stai lavorando in portoghese (brasiliano)',
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Traduci in portoghese (brasiliano)',
    'fabric.editor.ai.config.item.translateTo.russian.description': 'Traduce il testo su cui stai lavorando in russo',
    'fabric.editor.ai.config.item.translateTo.russian.title': 'Traduci in russo',
    'fabric.editor.ai.config.item.translateTo.spanish.description': 'Traduce il testo su cui stai lavorando in spagnolo',
    'fabric.editor.ai.config.item.translateTo.spanish.title': 'Traduci in spagnolo',
    'fabric.editor.ai.config.item.translateTo.swedish.description': 'Traduce il testo su cui stai lavorando in svedese',
    'fabric.editor.ai.config.item.translateTo.swedish.title': 'Traduci in svedese',
    'fabric.editor.ai.config.item.translateTo.thai.description': 'Traduce il testo su cui stai lavorando in thailandese',
    'fabric.editor.ai.config.item.translateTo.thai.title': 'Traduci in thailandese',
    'fabric.editor.ai.config.item.translateTo.turkish.description': 'Traduce il testo su cui stai lavorando in turco',
    'fabric.editor.ai.config.item.translateTo.turkish.title': 'Traduci in turco',
    'fabric.editor.ai.config.item.translateTo.ukrainian.description': 'Traduce il testo su cui stai lavorando in ucraino',
    'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Traduci in ucraino',
    'fabric.editor.ai.config.item.translateTo.vietnamese.description': 'Traduce il testo su cui stai lavorando in vietnamita',
    'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Traduci in vietnamita',
    'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Cambia il tono',
    'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Riscrivi',
    'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Traduci',
    'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Titolo della pagina',
    'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Pagina',
    'fabric.editor.ai.experience-application.documentInsertError': "Stiamo riscontrando problemi nell'inserimento della risposta. Chiudi la finestra di dialogo e riprova.",
    'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage': "Stiamo riscontrando problemi nella generazione dell'anteprima. Chiudi la finestra di dialogo e riprova.",
    'fabric.editor.ai.experience-application.rateLimitEnforced': "Abbiamo ricevuto troppe richieste recenti per Atlassian Intelligence (AI). Riprova tra qualche minuto o informati sull'<link>uso eccessivo di AI</link>.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': 'Impossibile ottenere una risposta. La tua richiesta o risposta superava il limite consentito per questa richiesta. Chiudi la finestra di dialogo e riprova.',
    'fabric.editor.ai.experience-application.unhandledErrorMessage': 'Stiamo riscontrando problemi. Chiudi la finestra di dialogo e riprova.',
    'fabric.editor.ai.experience.apiError': 'Impossibile ottenere una risposta, riprova.',
    'fabric.editor.ai.experience.aupViolationMessage': "Il tuo prompt o il tuo contenuto potrebbero non essere conformi alla nostra Policy sull'utilizzo accettabile. Verificali entrambi e, se necessario, consulta la nostra <link>Policy sull'utilizzo accettabile</link>. Se il problema persiste, valuta la possibilit\xe0 di provare con un prompt o un contenuto diverso.",
    'fabric.editor.ai.experience.browseMore.agents': 'Sfoglia agenti',
    'fabric.editor.ai.experience.discardMessagePrompt': 'Vuoi eliminare la tua richiesta?',
    'fabric.editor.ai.experience.discardMessageResponse': 'Vuoi eliminare la tua risposta?',
    'fabric.editor.ai.experience.elevateDisabledGenetateError': "La scrittura libera dei prompt \xe8 disabilitata in Elevate in questa fase.",
    'fabric.editor.ai.experience.engagementBannerLinksText': "\uD83D\uDE80 Ora puoi incollare link \uD83D\uDD17 ai contenuti di Jira e Confluence nei tuoi prompt.",
    'fabric.editor.ai.experience.footerRightText.agents': 'Con tecnologia Rovo',
    'fabric.editor.ai.experience.hipaaContentError': 'Atlassian Intelligence non ha potuto elaborare la tua richiesta in quanto nel contenuto sono presenti link a contenuti soggetti a restrizioni HIPAA. Rimuovi questi link e riprova.',
    'fabric.editor.ai.experience.inputTooShortError': "Il contenuto \xe8 troppo breve per essere riassunto. Aggiungine altro e riprova.",
    'fabric.editor.ai.experience.internalServerError': "Atlassian Intelligence (AI) non risponde. Riprova pi\xf9 tardi o <link>controlla lo stato di AI</link>.",
    'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
    'fabric.editor.ai.experience.loadingTitle': 'Generazione in corso',
    'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analisi: revisione della tua domanda.',
    'fabric.editor.ai.experience.messageTemplateContentSearch': 'Ricerca: attendi un istante mentre viene eseguita la ricerca delle informazioni.',
    'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Ricerca: attendi un istante mentre viene eseguita la ricerca in Jira.',
    'fabric.editor.ai.experience.messageTemplatePageHydration': 'Ricerca: attendi un istante mentre viene eseguita la ricerca della pagina.',
    'fabric.editor.ai.experience.noResultsSuggestion': 'Nessun risultato',
    'fabric.editor.ai.experience.responseTooSimilarMessage': 'Atlassian Intelligence non ha suggerimenti al momento. Prova con un prompt o un contenuto diverso.',
    'fabric.editor.ai.experience.showMoreButton': "Mostra di pi\xf9",
    'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Azioni',
    'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenti',
    'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Fonte di conoscenza',
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agenti Rovo',
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agenti Rovo ({numberOfAgents})',
    'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Usa un agente Rovo ({numberOfAgents})',
    'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Usa le conoscenze generali',
    'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Usa le conoscenze della tua organizzazione',
    'fabric.editor.ai.proactive.error.markdownErrorMessage': "Stiamo riscontrando problemi nella generazione dell'anteprima. Chiudi la finestra di dialogo e riprova.",
    'fabric.editor.ai.proactive.error.unhandledErrorMessage': 'Stiamo riscontrando problemi. Chiudi la finestra di dialogo e riprova.',
    'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Inserisci sotto',
    'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Sostituisci',
    'fabric.editor.ai.screens.preview.convoAIBeta': 'Le richieste di generazione di contenuti che fanno riferimento agli URL sono nella versione beta.',
    'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': "Evidenzia un termine, un acronimo o un'abbreviazione",
    'fabric.editor.ai.selectionToolbar.define.title': 'Definisci',
    'fabric.editor.ai.toolbar.askAI.title': 'Chiedi ad Atlassian Intelligence',
    'fabric.editor.ai.toolbar.improveWriting.title': 'Migliora lo stile',
    'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Indica ad Atlassian Intelligence di migliorare il contenuto da te selezionato',
    'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
    'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
    'fabric.editor.ai.toolbar.tryAI.title': 'Prova AI',
    'fabric.editor.ai.toolbar.tryAI.tooltip': 'Apri Atlassian Intelligence',
    'fabric.editor.alignCenter': 'Allinea al centro',
    'fabric.editor.alignImageCenter': 'Allinea al centro',
    'fabric.editor.alignImageLeft': 'Allinea a sinistra',
    'fabric.editor.alignImageRight': 'Allinea a destra',
    'fabric.editor.alignLeft': 'Allinea a sinistra',
    'fabric.editor.alignRight': 'Allinea a destra',
    'fabric.editor.alignTableCenter': 'Allinea al centro',
    'fabric.editor.alignTableLeft': 'Allinea a sinistra',
    'fabric.editor.alignment': 'Allineamento testo',
    'fabric.editor.altText': 'Testo alternativo',
    'fabric.editor.alttext.validation': 'Rimuovi eventuali caratteri speciali dal testo alternativo.',
    'fabric.editor.annotationToolbar': 'Barra degli strumenti di annotazione',
    'fabric.editor.backLink': 'Torna indietro',
    'fabric.editor.backgroundColor': 'Colore di sfondo',
    'fabric.editor.blockCardUnavailable': "Il collegamento in linea \xe8 all'interno di {node} e non \xe8 possibile modificare la relativa visualizzazione",
    'fabric.editor.blockControlDelete': 'Elimina',
    'fabric.editor.blockControlDragHandleMove': 'Trascina per spostare',
    'fabric.editor.blockControlDragHandleRearrange': 'Trascina per riorganizzare',
    'fabric.editor.blockControlInsert': 'Inserisci',
    'fabric.editor.blockControlMoveDown': "Sposta gi\xf9",
    'fabric.editor.blockControlMoveLeft': 'Sposta a sinistra',
    'fabric.editor.blockControlMoveRight': 'Sposta a destra',
    'fabric.editor.blockControlMoveUp': 'Sposta su',
    'fabric.editor.blockControlMovedDown': "Il contenuto \xe8 stato spostato verso il basso",
    'fabric.editor.blockControlMovedUp': "Il contenuto \xe8 stato spostato verso l'alto",
    'fabric.editor.blockDescription': 'Visualizza ulteriori informazioni relative al link, come riepilogo e azioni',
    'fabric.editor.blockTitle': 'Scheda',
    'fabric.editor.blockquote': 'una virgoletta',
    'fabric.editor.blockquote.description': 'Inserisci citazione',
    'fabric.editor.blockquote2': 'Citazione',
    'fabric.editor.bold': 'Grassetto',
    'fabric.editor.breakoutFullWidthLabel': 'Larghezza piena',
    'fabric.editor.breakoutWideWidthLabel': 'Largo',
    'fabric.editor.bug': 'Bug',
    'fabric.editor.canNotSortTable': "\u26A0\uFE0F Non puoi ordinare una tabella con celle unite",
    'fabric.editor.cancelButton': 'Annulla',
    'fabric.editor.captionPlaceholder': 'Aggiungi didascalia',
    'fabric.editor.captionPlaceholderWithDoubleClickPrompt': "Aggiungi una didascalia (doppio clic per visualizzare l'anteprima)",
    'fabric.editor.cardFloatingControls': 'Opzioni scheda',
    'fabric.editor.cellBackground': 'Sfondo cella',
    'fabric.editor.cellOptions': 'Opzioni cella',
    'fabric.editor.checkUncheckActionItem': "Attiva/disattiva l'elemento di azione",
    'fabric.editor.clearAltTextEdit': 'Cancella testo alternativo',
    'fabric.editor.clearCells': '{0, plural, one {Cancella cella} other {Cancella celle}}',
    'fabric.editor.clearFormatting': 'Elimina formattazione',
    'fabric.editor.clearLink': 'Cancella link',
    'fabric.editor.clearLinkText': 'Cancella testo',
    'fabric.editor.closeAltTextEdit': 'Indietro',
    'fabric.editor.closeFindReplaceDialog': 'Chiudi',
    'fabric.editor.closeHelpDialog': 'Chiudi la finestra della guida',
    'fabric.editor.code': 'Codice',
    'fabric.editor.code.on': '{textFormattingOff}, codice attivato',
    'fabric.editor.codeBidiWarningLabel': "I caratteri bidirezionali modificano l'ordine in cui \xe8 visualizzato il testo. Possono essere utilizzati per nascondere un codice dannoso.",
    'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Copiato.',
    'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Copia come testo',
    'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Disattiva ritorno a capo',
    'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Attiva ritorno a capo',
    'fabric.editor.codeblock': 'Frammento di codice',
    'fabric.editor.codeblock.description': 'Mostra codice con colorazione della sintassi',
    'fabric.editor.collapseNode': 'Comprimi contenuto',
    'fabric.editor.collapseTable': 'Comprimi tabella',
    'fabric.editor.colorPicker.menuLabel': 'Menu del selettore colori',
    'fabric.editor.columnDragHandle': 'Opzioni colonna',
    'fabric.editor.columnMovedLeft': 'Colonna spostata a sinistra della colonna {index} di {total}',
    'fabric.editor.columnMovedRight': 'Colonna spostata a destra della colonna {index} di {total}',
    'fabric.editor.columnSelected': 'Colonna {index} di {total} selezionata',
    'fabric.editor.columns': 'Layout',
    'fabric.editor.columns.advanced.layout.description': '{numberOfColumns, plural, one {Inserisci {numberOfColumns} colonna uguale} other {Inserisci {numberOfColumns} colonne uguali}}',
    'fabric.editor.columns.advanced.layout.single.description': 'Inserisci un layout a colonna singola',
    'fabric.editor.columns.description': 'Organizza la tua pagina in sezioni',
    'fabric.editor.columnsAreInserted': "{count, plural, one {\xc8 stata inserita una colonna} other {Sono state inserite {count} colonne}}",
    'fabric.editor.columnsAreRemoved': "{count, plural, one {La colonna \xe8 stata rimossa} other {Sono state rimosse {count} colonne}}",
    'fabric.editor.configFailedToLoad': 'Caricamento non riuscito',
    'fabric.editor.configPanel.cancel': 'Annulla',
    'fabric.editor.configPanel.close': 'Chiudi',
    'fabric.editor.configPanel.customSelect.createOption': 'Crea',
    'fabric.editor.configPanel.dateRange.custom.from': 'Da',
    'fabric.editor.configPanel.dateRange.custom.to': 'a',
    'fabric.editor.configPanel.dateRange.grouping.collapse': 'Comprimi',
    'fabric.editor.configPanel.dateRange.grouping.expand': 'Espandi',
    'fabric.editor.configPanel.dateRange.option.custom': 'Personalizzato',
    'fabric.editor.configPanel.documentation': 'Documentazione',
    'fabric.editor.configPanel.errorBoundary.note': 'Abbiamo informato il team. Puoi ancora modificare e pubblicare questa pagina; per ulteriori informazioni, consulta la console degli errori.',
    'fabric.editor.configPanel.errorBoundary.title': "Si \xe8 verificato un errore.",
    'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Impossibile combinare isMultiple con style: radio',
    'fabric.editor.configPanel.formType.addField': 'Aggiungi campo',
    'fabric.editor.configPanel.formType.removeField': 'Rimuovi campo',
    'fabric.editor.configPanel.help': 'Serve aiuto?',
    'fabric.editor.configPanel.invalid': 'Campo non valido',
    'fabric.editor.configPanel.required': 'Campo obbligatorio',
    'fabric.editor.configPanel.submit': 'Invia',
    'fabric.editor.copiedToClipboard': 'Copiato.',
    'fabric.editor.copyToClipboard': 'Copia',
    'fabric.editor.cornerControl': 'Evidenzia tabella',
    'fabric.editor.createComment': 'Commento',
    'fabric.editor.createCommentDisabled': 'Puoi commentare solo testo, titoli, emoji, date, menzioni, link e stati.',
    'fabric.editor.createCommentInvalid': 'Puoi inserire commenti solo per il testo e le intestazioni',
    'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Ho capito',
    'fabric.editor.createCommentOnInlineNodeSpotlight.body': 'Ora puoi lasciare commenti su elementi in linea come link, date, stati e menzioni.',
    'fabric.editor.customPanel': 'Pannello personalizzato',
    'fabric.editor.customPanel.description': 'Aggiungi una nota con un emoji e uno sfondo colorato',
    'fabric.editor.datasource.assetsObjects.description': 'Inserisci oggetti da Risorse in Jira Service Management con la ricerca e i filtri',
    'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Risorse',
    'fabric.editor.datasource.confluenceSearch': "Inserisci l'elenco Confluence",
    'fabric.editor.datasource.confluenceSearch.description': "Inserisci l'elenco dei risultati della ricerca di Confluence con funzioni avanzate di ricerca, filtro e configurazione.",
    'fabric.editor.datasource.jiraIssue': 'Ticket Jira',
    'fabric.editor.datasource.jiraIssue.description': 'Inserisci ticket Jira da Jira Cloud con la ricerca avanzata, i filtri e la configurazione.',
    'fabric.editor.datasource.jiraIssue.description.issue-term-refresh': 'Inserisci i ticket Jira da Jira Cloud con la ricerca avanzata, i filtri e la configurazione.',
    'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Ticket Jira',
    'fabric.editor.datasourceAppearanceTitle': 'Elenco',
    'fabric.editor.datasourceTitle': 'Modifica query di ricerca',
    'fabric.editor.date': 'Data',
    'fabric.editor.date.description': 'Aggiungi una data usando un calendario',
    'fabric.editor.datePickerOpenedAlert': "Finestra a comparsa dell'editor della data aperta; premi Tab per accedere alla finestra a comparsa",
    'fabric.editor.decision': 'Decisione',
    'fabric.editor.decision.description': 'Acquisisci decisioni per monitorarle agevolmente',
    'fabric.editor.decisionPlaceholder': "Aggiungi una decisione\u2026",
    'fabric.editor.decreaseSize': "Riduci le dimensioni della tabella o dell'elemento multimediale",
    'fabric.editor.defaultAltText': 'Documento',
    'fabric.editor.delete': 'Elimina',
    'fabric.editor.description': 'Descrizione',
    'fabric.editor.displayBlock': 'Visualizza come scheda',
    'fabric.editor.displayEmbed': 'Visualizza come oggetto incorporato',
    'fabric.editor.displayInline': 'Visualizza in linea',
    'fabric.editor.displayLink': 'Mostra come testo',
    'fabric.editor.displayOptionUnavailableInParentNode': "Questa opzione di visualizzazione non \xe8 disponibile all'interno di {node}",
    'fabric.editor.displayText': 'Testo da mostrare',
    'fabric.editor.distributeColumns': 'Distribuisci colonne',
    'fabric.editor.dropPlaceholderLabel': 'Documento',
    'fabric.editor.ecombedDescription': "Visualizza un'anteprima interattiva di un link",
    'fabric.editor.edit': 'Modifica',
    'fabric.editor.edit.datasource': 'Modifica query di ricerca',
    'fabric.editor.edit.searchInput': 'Aggiungi un link',
    'fabric.editor.editAccessTitle': 'Devi avere accesso in modifica',
    'fabric.editor.editAltText': 'Modifica testo alternativo',
    'fabric.editor.editDatasourceStandalone': 'Modifica',
    'fabric.editor.editDatasourceStandaloneTooltip': 'Modifica la query di ricerca',
    'fabric.editor.editDateText': 'Modifica data',
    'fabric.editor.editDropdownEditDatasourceTitle': 'Modifica la query di ricerca',
    'fabric.editor.editDropdownEditLinkTitle': 'Modifica il link',
    'fabric.editor.editDropdownExpandIconLabel': 'Espandi il menu a discesa',
    'fabric.editor.editDropdownTriggerTitle': 'Modifica',
    'fabric.editor.editLink': 'Modifica link',
    'fabric.editor.editMode.inviteToEditButton.title': 'Invita a modificare',
    'fabric.editor.editStatusColor': 'Modifica colore stato',
    'fabric.editor.editStatusText': 'Modifica stato',
    'fabric.editor.editableContentLabel': 'Contenuto modificabile',
    'fabric.editor.editorHelp': "Guida dell'editor",
    'fabric.editor.editors': 'Editor',
    'fabric.editor.elementBrowser.help': 'Guida',
    'fabric.editor.elementInsertSidePanel.title': 'Inserisci',
    'fabric.editor.elementbrowser.categorylist.category-admin': 'Amministrazione',
    'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
    'fabric.editor.elementbrowser.categorylist.category-all': 'Tutto',
    'fabric.editor.elementbrowser.categorylist.category-communication': 'Comunicazione',
    'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Contenuto di Confluence',
    'fabric.editor.elementbrowser.categorylist.category-development': 'Sviluppo',
    'fabric.editor.elementbrowser.categorylist.category-external-content': 'Contenuto esterno',
    'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formattazione',
    'fabric.editor.elementbrowser.categorylist.category-media': 'Contenuti multimediali',
    'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigazione',
    'fabric.editor.elementbrowser.categorylist.category-reporting': 'Creazione di report',
    'fabric.editor.elementbrowser.categorylist.category-visuals': 'Elementi visivi e immagini',
    'fabric.editor.elementbrowser.search.empty-state.heading': 'Non ci sono risultati per la tua ricerca',
    'fabric.editor.elementbrowser.search.empty-state.sub-heading': 'Prova a ripetere la ricerca con un termine diverso o scopri nuove app per i prodotti Atlassian.',
    'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': "Esplora l'Atlassian Marketplace",
    'fabric.editor.elementbrowser.searchbar.assistive.text.default': '{count, plural, =0 {Nessun risultato corrispondente alla ricerca.} one {{count} suggerimento disponibile per impostazione predefinita.} other {{count} suggerimenti disponibili per impostazione predefinita.}}',
    'fabric.editor.elementbrowser.searchbar.assistive.text.result': '{count, plural, =0 {Nessun risultato corrispondente alla ricerca.} one {{count} suggerimento disponibile per il testo digitato.} other {{count} suggerimenti disponibili per il testo digitato.}}',
    'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Inserisci',
    'fabric.editor.elementbrowser.searchbar.placeholder': 'Cerca',
    'fabric.editor.elementbrowser.sidebar.heading': 'Sfoglia',
    'fabric.editor.embedTitle': 'Incorpora',
    'fabric.editor.emoji': 'Emoji',
    'fabric.editor.emoji.description': "Usa le emoji per esprimere idee \uD83C\uDF89 ed emozioni \uD83D\uDE04",
    'fabric.editor.emptyLink': 'Inserisci un link.',
    'fabric.editor.emptySearchResults': 'Impossibile trovare risultati.',
    'fabric.editor.emptySearchResultsSuggestion': 'Seleziona {buttonName} per sfogliare gli inserimenti.',
    'fabric.editor.epic': 'Epic',
    'fabric.editor.error': 'Errore',
    'fabric.editor.errorPanel': 'Pannello errori',
    'fabric.editor.errorPanel.description': 'Segnala gli errori in un pannello colorato',
    'fabric.editor.expand': 'Espandi',
    'fabric.editor.expand.description': 'Inserisci espansione',
    'fabric.editor.expandAriaLabel': 'Assegna un titolo a questa espansione',
    'fabric.editor.expandDefaultTitle': 'Clicca qui per espandere...',
    'fabric.editor.expandNode': 'Espandi contenuto',
    'fabric.editor.expandPlaceholder': 'Assegna un titolo a questa espansione...',
    'fabric.editor.extension.confirmDeleteLinkedModalMessage': "L'eliminazione di {nodeName} comporter\xe0 l'interruzione di tutti i relativi collegamenti.",
    'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Eliminazione in corso',
    'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Elimina',
    'fabric.editor.extension.deleteElementTitle': "Elimina l'elemento",
    'fabric.editor.extension.sourceNoTitledName': 'questo elemento',
    'fabric.editor.extensions.config-panel.save-indicator': 'Le modifiche vengono sempre salvate automaticamente',
    'fabric.editor.externalExtensionsHeading': 'App',
    'fabric.editor.externalMediaFile': 'File multimediale esterno',
    'fabric.editor.failed_to_upload': 'Impossibile caricare',
    'fabric.editor.feedbackDialog': 'Lascia un feedback',
    'fabric.editor.feedbackDialog.description': 'Raccontaci la tua esperienza usando il nuovo editor',
    'fabric.editor.find': 'Trova',
    'fabric.editor.findNext': 'Trova successivo',
    'fabric.editor.findPrevious': 'Trova precedente',
    'fabric.editor.findReplaceToolbarButton': 'Trova e sostituisci',
    'fabric.editor.fiveColumns': 'Layout a 5 colonne',
    'fabric.editor.floatingToolbar.confirmModalCancel': 'Annulla',
    'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Elimina anche gli elementi collegati',
    'fabric.editor.floatingToolbar.confirmModalConnectedUnit': '{amount, plural, =0 {{name}} one {{name} (+1 elemento collegato)} other {{name} (+{amount,number} elementi collegati)}}',
    'fabric.editor.floatingToolbar.confirmModalHeading': 'Confermi?',
    'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
    'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Sono stati aperti i controlli della barra degli strumenti mobile',
    'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Barra degli strumenti mobile',
    'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Opzioni di layout',
    'fabric.editor.floatingToolbar.scrollLeft': 'Scorri a sinistra',
    'fabric.editor.floatingToolbar.scrollRight': 'Scorri a destra',
    'fabric.editor.focusTableResizeHandle': 'Quadratino di ridimensionamento della tabella Focus',
    'fabric.editor.fourColumns': 'Layout a 4 colonne',
    'fabric.editor.headerColumn': 'Colonna di intestazione',
    'fabric.editor.headerRow': 'Riga di intestazione',
    'fabric.editor.heading1': 'Titolo 1',
    'fabric.editor.heading1Description': 'Per un titolo di primo livello',
    'fabric.editor.heading2': 'Titolo 2',
    'fabric.editor.heading2Description': 'Per le sezioni principali',
    'fabric.editor.heading3': 'Titolo 3',
    'fabric.editor.heading3Description': 'Per i titoli delle sottosezioni e dei gruppi',
    'fabric.editor.heading4': 'Titolo 4',
    'fabric.editor.heading4Description': 'Per i titoli interni',
    'fabric.editor.heading5': 'Titolo 5',
    'fabric.editor.heading5Description': 'Per le voci degli elenchi',
    'fabric.editor.heading6': 'Titolo 6',
    'fabric.editor.heading6Description': 'Per i titoli di livello inferiore',
    'fabric.editor.headingLink.ascOrderLabel': 'Ordina colonna da Z ad A',
    'fabric.editor.headingLink.descOrderLabel': "Cancella l'ordinamento",
    'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
    'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
    'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Ticket',
    'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Ticket',
    'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Pagina',
    'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
    'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Task',
    'fabric.editor.headingLink.invalidLabel': "\u26A0\uFE0F Non puoi ordinare una tabella con celle unite",
    'fabric.editor.headingLink.noOrderLabel': 'Ordina colonna da A a Z',
    'fabric.editor.help': 'Guida',
    'fabric.editor.help.description': 'Sfoglia tutti i tasti di scelta rapida e le opzioni di Markdown',
    'fabric.editor.helpDialogTips': 'Premi {keyMap} per aprire velocemente questa finestra di dialogo ogni volta che vuoi',
    'fabric.editor.highlight': 'Colore di evidenziazione',
    'fabric.editor.highlightColor': 'Attiva/disattiva la palette dei colori di evidenziazione',
    'fabric.editor.highlightFloatingToolbar': 'Evidenzia',
    'fabric.editor.horizontalRule': 'Divisore',
    'fabric.editor.horizontalRule.description': 'Contenuti separati con una riga orizzontale',
    'fabric.editor.hyperlink.linkVisibleLabel': 'Incolla o cerca il link',
    'fabric.editor.hyperlink.searchLinkAriaDescription': 'I suggerimenti vengono visualizzati durante la digitazione nel campo',
    'fabric.editor.hyperlink.searchLinkResults': '{count, plural, =0 {nessun risultato trovato} one {{count,number} risultato trovato} other {{count,number} risultati trovati}}',
    'fabric.editor.hyperlink.textVisibleLabel': 'Testo visualizzato (opzionale)',
    'fabric.editor.hyperlinkToolbarPlaceholder': 'Incolla o cerca il link',
    'fabric.editor.image': 'Immagine',
    'fabric.editor.image.fullWidthLabel': 'Larghezza piena',
    'fabric.editor.imageBorderBold': 'Grassetto',
    'fabric.editor.imageBorderColor': 'Colore',
    'fabric.editor.imageBorderColor.dropdownAriaLabel': "Menu a discesa Colore nelle opzioni per il bordo dell'immagine",
    'fabric.editor.imageBorderMedium': 'Medio',
    'fabric.editor.imageBorderOptions': 'Opzioni bordo',
    'fabric.editor.imageBorderSize': 'Dimensione',
    'fabric.editor.imageBorderSize.dropdownAriaLabel': "Menu a discesa Dimensioni nelle opzioni per il bordo dell'immagine",
    'fabric.editor.imageBorderSubtle': 'Sottile',
    'fabric.editor.improvement': 'Miglioramento',
    'fabric.editor.increaseSize': "Aumenta le dimensioni della tabella o dell'elemento multimediale",
    'fabric.editor.indent': 'Rientra',
    'fabric.editor.info': 'Info',
    'fabric.editor.infoPanel': 'Pannello informazioni',
    'fabric.editor.infoPanel.description': "Metti in evidenza l\u2019informazione in un pannello colorato",
    'fabric.editor.inlineConfigureLink': 'Configura il link',
    'fabric.editor.inlineDescription': 'Visualizza il link come testo in linea',
    'fabric.editor.inlineGoToLink': 'Vai al link',
    'fabric.editor.inlineOverlay': 'Configura',
    'fabric.editor.inlineTitle': 'In linea',
    'fabric.editor.inputQueryAssistiveTxt': "Una volta che i risultati del completamento automatico sono disponibili, utilizza le frecce su e gi\xf9 per rivedere i dati e premi Invio per selezionarli. Gli utenti di dispositivi touch possono utilizzare i movimenti di tocco o scorrimento.",
    'fabric.editor.insertColumn': 'Inserisci colonna a destra',
    'fabric.editor.insertColumnDrag': 'Inserisci colonna',
    'fabric.editor.insertMenu': 'Inserisci elementi',
    'fabric.editor.insertRightRail.close': 'Chiudi',
    'fabric.editor.insertRightRail.title': 'Inserisci',
    'fabric.editor.insertRow': 'Inserisci riga sotto',
    'fabric.editor.insertRowDrag': 'Inserisci riga',
    'fabric.editor.insertTableColumn': 'Inserisci la colonna della tabella',
    'fabric.editor.insertTableRow': 'Inserisci la riga della tabella',
    'fabric.editor.invalidDateError': 'Inserisci una data valida',
    'fabric.editor.invalidLink': 'Inserisci un link valido.',
    'fabric.editor.inviteItem.title': '{userRole, select, admin {Invita un collega in {productName}} trusted {Invita un collega in {productName}} other {Aggiunti un collega a {productName}}}',
    'fabric.editor.italic': 'Corsivo',
    'fabric.editor.keyboardShortcuts': 'Scelte rapide da tastiera',
    'fabric.editor.layout.columnOption': '{count, plural, one {Colonna} other {{count} colonne}}',
    'fabric.editor.layout.controls.placeholder': '/ per inserire',
    'fabric.editor.layout.placeholder': 'Aggiungi contenuti',
    'fabric.editor.layout.resizeLayout': 'Ridimensiona layout',
    'fabric.editor.layoutFixedWidth': 'Torna alla visualizzazione centrata',
    'fabric.editor.layoutFullWidth': 'Vai alla vista a schermo intero',
    'fabric.editor.layoutStateFixedWidth': 'Centrato',
    'fabric.editor.layoutStateFullWidth': 'Larghezza intera',
    'fabric.editor.layoutStateWide': 'Largo',
    'fabric.editor.layoutWide': 'Allarga',
    'fabric.editor.leftSidebar': 'Layout con barra laterale sinistra',
    'fabric.editor.link': 'Inserisci link',
    'fabric.editor.link.description': 'Inserisci un link',
    'fabric.editor.linkAddress': 'Collega indirizzo',
    'fabric.editor.linkPlaceholder': 'Incolla link',
    'fabric.editor.lists': 'Elenchi',
    'fabric.editor.listsFormat': 'Formattazione degli elenchi',
    'fabric.editor.lockColumns': 'Larghezze fisse delle colonne',
    'fabric.editor.longEmptyNodePlaceholderText': 'Digita / per inserire gli elementi',
    'fabric.editor.markdown': 'Markdown',
    'fabric.editor.matchCase': 'Maiuscole/Minuscole',
    'fabric.editor.media.DefaultMediaWidthDecreased': "{newMediaWidth, plural, one {La larghezza dell'elemento multimediale \xe8 stata ridotta a {newMediaWidth,number} pixel.} other {La larghezza dell'elemento multimediale \xe8 stata ridotta a {newMediaWidth,number} pixel.}}",
    'fabric.editor.media.DefaultMediaWidthIncreased': "{newMediaWidth, plural, one {La larghezza dell'elemento multimediale \xe8 stata aumentata a {newMediaWidth,number} pixel.} other {La larghezza dell'elemento multimediale \xe8 stata aumentata a {newMediaWidth,number} pixel.}}",
    'fabric.editor.media.MediaWidthIsMin': 'Elemento multimediale ridotto alla dimensione minima',
    'fabric.editor.media.insert.cancel': 'Annulla',
    'fabric.editor.media.insert.fileTabTitle': 'File',
    'fabric.editor.media.insert.fromUrlErrorMessage': "Impossibile aggiungere il link a questa immagine. Scarica l'immagine, quindi trascinala nella pagina.",
    'fabric.editor.media.insert.fromUrlWarning': "L'immagine potrebbe non essere visibile agli altri a causa di restrizione dell'origine. Valuta la possibilit\xe0 di caricare i file.",
    'fabric.editor.media.insert.insert': 'Inserisci',
    'fabric.editor.media.insert.invalidUrlErrorMessage': 'Link non valido',
    'fabric.editor.media.insert.linkTabTitle': 'Link',
    'fabric.editor.media.insert.loadPreview': 'Carica anteprima',
    'fabric.editor.media.insert.localFileErrorMessage': "Questo file non pu\xf2 essere caricato.",
    'fabric.editor.media.insert.localFileNetworkErrorMessage': 'Errore di caricamento del file. Controlla il percorso del file o la rete.',
    'fabric.editor.media.insert.mediaAlt': "Anteprima del file del video o dell'immagine caricato",
    'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Selettore di file multimediali',
    'fabric.editor.media.insert.pasteLinkToUpload': 'Incolla il link per caricare',
    'fabric.editor.media.insert.upload': 'Carica',
    'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Elemento multimediale aumentato alla dimensione massima',
    'fabric.editor.media.pixelEntry.ResizeOption': 'Ridimensiona',
    'fabric.editor.media.pixelEntry.closePixelEntry': 'Chiudi',
    'fabric.editor.media.pixelEntry.inputHeightAriaLabel': "campo di inserimento dell'altezza",
    'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Altezza',
    'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Larghezza max {maxWidth} px',
    'fabric.editor.media.pixelEntry.inputWidthLabel': 'Larghezza',
    'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Larghezza max {maxWidth} px',
    'fabric.editor.media.pixelEntry.migrationButtonText': 'Converti in pixel',
    'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migra dalla dimensione percentuale alla dimensione in pixel fissa',
    'fabric.editor.media.pixelEntry.submitButtonText': 'Invia',
    'fabric.editor.media.pixelEntry.validationFailedMessage': 'Convalida della larghezza non riuscita',
    'fabric.editor.mediaAddLink': 'Aggiungi link',
    'fabric.editor.mediaFiles': 'Immagine, video o file',
    'fabric.editor.mediaFiles.description': 'Aggiungi alla tua pagina immagini e altri file',
    'fabric.editor.mediaGroupDeleteLabel': 'elimina',
    'fabric.editor.media_change_mediainline_caption_warn': "In linea (la didascalia sar\xe0 rimossa)",
    'fabric.editor.media_change_mediainline_default': 'In linea',
    'fabric.editor.media_change_mediasingle': 'Dimensione originale',
    'fabric.editor.mention': 'Menziona',
    'fabric.editor.mention.description': 'Menziona qualcuno per inviargli una notifica',
    'fabric.editor.mentionNode.label': 'Utente taggato',
    'fabric.editor.mentionsAddLabel': 'icona aggiungi',
    'fabric.editor.mentionsIconLabel': 'Menziona',
    'fabric.editor.mergeCells': 'Unisci celle',
    'fabric.editor.moreFormatting': 'Formattazione aggiuntiva',
    'fabric.editor.moveColumnLeft': '{0, plural, one {Sposta colonna a sinistra} other {Sposta colonne a sinistra}}',
    'fabric.editor.moveColumnRight': '{0, plural, one {Sposta colonna a destra} other {Sposta colonne a destra}}',
    'fabric.editor.moveDownDown': '{0, plural, one {Sposta riga in basso} other {Sposta righe in basso}}',
    'fabric.editor.moveRowUp': '{0, plural, one {Sposta riga in alto} other {Sposta righe in alto}}',
    'fabric.editor.navigate.toolbar.editor': "Passa alla barra degli strumenti dell'editor",
    'fabric.editor.navigate.toolbar.floating': 'Passa alla barra degli strumenti mobile',
    'fabric.editor.noResultsFound': 'Nessun risultato',
    'fabric.editor.noSearchResults': 'Nessun risultato della ricerca',
    'fabric.editor.normal': 'Testo normale',
    'fabric.editor.note': 'Nota',
    'fabric.editor.notePanel': 'Pannello note',
    'fabric.editor.notePanel.description': 'Aggiungi una nota in un pannello colorato',
    'fabric.editor.numberedColumn': 'Colonna numerata',
    'fabric.editor.off': '{formattingType} disattiva',
    'fabric.editor.offlineErrorFallbackDescription': 'Prova a ricaricare la pagina.',
    'fabric.editor.offlineErrorFallbackHeading': "Si \xe8 verificato un problema.",
    'fabric.editor.on': '{formattingType} attiva',
    'fabric.editor.openCellOptions': 'Apri opzioni cella',
    'fabric.editor.openLink': 'Apri link in una nuova scheda',
    'fabric.editor.orderedList': 'Elenco numerato',
    'fabric.editor.orderedList.description': 'Crea una lista ordinata',
    'fabric.editor.other': 'Altri...',
    'fabric.editor.outdent': 'Annulla rientro',
    'fabric.editor.overflowMenuViewMore': 'Visualizza altro',
    'fabric.editor.pageActionsLabel': 'Azioni sulla pagina',
    'fabric.editor.panel': 'Pannello',
    'fabric.editor.panel.backgroundColor': 'Colore di sfondo',
    'fabric.editor.panel.custom': 'Personalizzato',
    'fabric.editor.panel.emoji': 'Aggiungi emoji',
    'fabric.editor.panel.panelsGroup': 'Tipi di riquadri',
    'fabric.editor.pasteOptions': 'Opzioni Incolla',
    'fabric.editor.pastePlainText': 'Incolla testo non formattato',
    'fabric.editor.placeholderAltText': 'Descrivi questa immagine con testo alternativo',
    'fabric.editor.placeholderText': 'Testo segnaposto',
    'fabric.editor.placeholderText.description': 'Inserisci un segnaposto di testo nella pagina',
    'fabric.editor.placeholderTextPlaceholder': 'Aggiungi testo segnaposto',
    'fabric.editor.plainText': 'Usa testo normale',
    'fabric.editor.preferencesLink': 'Preferenze per i link',
    'fabric.editor.quickInsert': 'Inserimento rapido',
    'fabric.editor.recordLoomShortTitle': 'Registra',
    'fabric.editor.recordVideo': 'Registra un video Loom',
    'fabric.editor.recordVideo.description': 'Registra e condividi il tuo schermo e i tuoi pensieri',
    'fabric.editor.redo': 'Ripeti',
    'fabric.editor.remove': 'Rimuovi',
    'fabric.editor.removeColumns': '{0, plural, one {Elimina colonna} other {Elimina colonne}}',
    'fabric.editor.removeEmoji': 'Rimuovi emoji',
    'fabric.editor.removeImageBorder': 'Rimuovi bordo',
    'fabric.editor.removeRows': '{0, plural, one {Elimina riga} other {Elimina righe}}',
    'fabric.editor.replace': 'Sostituisci',
    'fabric.editor.replaceAll': 'Sostituisci tutto',
    'fabric.editor.replaceSuccess': '{numberOfMatches, plural, one {{numberOfMatches,number} corrispondenza sostituita} other {{numberOfMatches,number} corrispondenze sostituite}}',
    'fabric.editor.replaceWith': 'Sostituisci con',
    'fabric.editor.requestToEdit': 'Richiesta per modificare',
    'fabric.editor.requestToEditDescription': "Quando richiedi l'accesso, il responsabile della pagina riceve una notifica.",
    'fabric.editor.requestToEditDismiss': 'Chiudi',
    'fabric.editor.resultsCount': '{selectedMatchPosition} di {totalResultsCount}',
    'fabric.editor.richText': 'Usa testo RTF',
    'fabric.editor.rightSidebar': 'Layout con barra laterale destra',
    'fabric.editor.rowControl': 'Evidenzia riga',
    'fabric.editor.rowDragHandle': 'Opzioni riga',
    'fabric.editor.rowMovedDown': 'Riga spostata sotto la riga {index} di {total}',
    'fabric.editor.rowMovedUp': 'Riga spostata sopra la riga {index} di {total}',
    'fabric.editor.rowSelected': 'Riga {index} di {total} selezionata',
    'fabric.editor.rowsAreInserted': "{count, plural, one {\xc8 stata inserita una riga} other {Sono state inserite {count} righe}}",
    'fabric.editor.rowsAreRemoved': "{count, plural, one {La riga \xe8 stata rimossa} other {Sono state rimosse {count} righe}}",
    'fabric.editor.saveButton': 'Salva',
    'fabric.editor.searchResults': "{itemsLength, plural, one {{itemsLength,number} risultato della ricerca disponibile. Usa i tasti di direzione su e gi\xf9 per spostarti tra le opzioni. Premi Invio per selezionare un'opzione.} other {{itemsLength,number} risultati della ricerca disponibili. Usa i tasti di direzione su e gi\xf9 per spostarti tra le opzioni. Premi Invio per selezionare un'opzione.}}",
    'fabric.editor.selectColumnResize': 'Seleziona il ridimensionamento della colonna',
    'fabric.editor.selectLanguage': 'Seleziona linguaggio',
    'fabric.editor.selectTableColumn': 'Seleziona la colonna della tabella',
    'fabric.editor.selectTableRow': 'Seleziona la riga della tabella',
    'fabric.editor.selectionExtensionDropdownButtonLabel': "Seleziona l'app",
    'fabric.editor.settingsLinks': 'Vai alle Preferenze per i link',
    'fabric.editor.shortEmptyNodePlaceholderText': '/ per inserire',
    'fabric.editor.shortcut': 'Scelta rapida di testo',
    'fabric.editor.single': 'Layout a colonna singola',
    'fabric.editor.singleColumns': 'Layout a 1 colonna',
    'fabric.editor.sortColumnASC': "Ordina colonna A \u2192 Z",
    'fabric.editor.sortColumnDESC': "Ordina colonna Z \u2192 A",
    'fabric.editor.sortColumnDecreasing': 'Ordinamento decrescente',
    'fabric.editor.sortColumnIncreasing': 'Ordinamento crescente',
    'fabric.editor.splitCell': 'Dividi cella',
    'fabric.editor.status': 'Stato',
    'fabric.editor.status.description': "Aggiungi un\u2019etichetta di stato personalizzato",
    'fabric.editor.statusEditorLabel': 'Editor di stato',
    'fabric.editor.statusPickerOpenedAlert': "Finestra a comparsa dell'editor di stato aperta; premi Tab per accedere alla finestra a comparsa",
    'fabric.editor.statusPlaceholder': 'Imposta uno stato',
    'fabric.editor.story': 'Story',
    'fabric.editor.strike': 'Barrato',
    'fabric.editor.subTask': 'Sottotask',
    'fabric.editor.subscript': 'Pedice',
    'fabric.editor.subscript.off.superscript.on': 'Pedice disattivato, Apice attivato',
    'fabric.editor.success': 'Operazione riuscita',
    'fabric.editor.successPanel': 'Pannello operazioni completate',
    'fabric.editor.successPanel.description': 'Aggiungi consigli in un pannello colorato',
    'fabric.editor.superscript': 'Apice',
    'fabric.editor.superscript.off.subscript.on': 'Apice disattivato, Pedice attivato',
    'fabric.editor.supportAltText': "Il testo alternativo \xe8 utile agli utenti con problemi di vista che utilizzano utilit\xe0 per la lettura dello schermo.",
    'fabric.editor.table': 'Tabella',
    'fabric.editor.table.description': 'Inserisci una tabella',
    'fabric.editor.tableAlignmentOptions': 'Opzioni di allineamento',
    'fabric.editor.tableFullWidthLabel': 'Larghezza piena',
    'fabric.editor.tableHeader.sorting.asc': 'Ordinamento crescente applicato',
    'fabric.editor.tableHeader.sorting.default': 'Ordina la colonna',
    'fabric.editor.tableHeader.sorting.desc': 'Ordinamento decrescente applicato',
    'fabric.editor.tableHeader.sorting.invalid': 'Non puoi ordinare una tabella con celle unite',
    'fabric.editor.tableHeader.sorting.no': 'Nessun ordinamento applicato alla colonna',
    'fabric.editor.tableOptions': 'Opzioni tabella',
    'fabric.editor.tableResizeDecreaseScreenReaderInformation': '{newWidth, plural, one {Larghezza della tabella diminuita a {newWidth,number} pixel.} other {Larghezza della tabella diminuita a {newWidth,number} pixel.}}',
    'fabric.editor.tableResizeIncreaseScreenReaderInformation': '{newWidth, plural, one {Larghezza della tabella aumentata a {newWidth,number} pixel.} other {Larghezza della tabella aumentata a {newWidth,number} pixel.}}',
    'fabric.editor.tableSelector': 'Dimensioni tabella',
    'fabric.editor.tableSelector.description': 'Aggiungi una tabella utilizzando la finestra popup per selezionare una dimensione personalizzata',
    'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} per {numberOfRows}',
    'fabric.editor.tableSizeSelectorPopup': 'Selettore delle dimensioni della tabella',
    'fabric.editor.tables.adjustColumn': 'Regola colonna',
    'fabric.editor.tables.columnResizeLast': 'Puoi ridimensionare questa colonna solo verso sinistra.',
    'fabric.editor.tables.columnResizeOverflow': 'Puoi ridimensionare questa colonna solo se la tabella dispone di una barra di scorrimento.',
    'fabric.editor.tables.columnWidth': "{width, plural, one {La larghezza della colonna \xe8 stata modificata in {width} pixel} other {La larghezza della colonna \xe8 stata modificata in {width} pixel}}",
    'fabric.editor.tables.confirmDeleteLinkedModalMessage': "L'eliminazione di {nodeName} comporter\xe0 l'interruzione di tutti i relativi collegamenti.",
    'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Elimina',
    'fabric.editor.tables.resizeStop': 'Ridimensionamento interrotto',
    'fabric.editor.tables.resizeTable': 'Ridimensiona tabella',
    'fabric.editor.tables.startedColumnResize': 'Ridimensionamento della colonna avviato',
    'fabric.editor.task': 'Task',
    'fabric.editor.taskPlaceholder': "Digita la tua azione e usa \u201C@\u201D per assegnarla a qualcuno.",
    'fabric.editor.text.formatting.off': 'Formattazione del test disattivata',
    'fabric.editor.textColor': 'Colore del testo {selectedColorName}',
    'fabric.editor.textColorTooltip': 'Colore del testo',
    'fabric.editor.textFormat': 'Formatta testo',
    'fabric.editor.textFormatting': 'Formattazione del testo',
    'fabric.editor.textStyles': 'Stili del testo {blockTypeName}',
    'fabric.editor.textStylesTooltip': 'Stili del testo',
    'fabric.editor.threeColumns': 'Layout a 3 colonne',
    'fabric.editor.threeColumnsWithLeftSidebars': 'Layout a tre colonne con barra laterale a sinistra',
    'fabric.editor.threeColumnsWithRightSidebars': 'Layout a tre colonne con barra laterale a destra',
    'fabric.editor.threeColumnsWithSidebars': 'Layout a tre colonne con barre laterali',
    'fabric.editor.time.ago': 'fa',
    'fabric.editor.time.updated': 'Aggiornato',
    'fabric.editor.time.viewed': 'Visualizzato',
    'fabric.editor.toolbarAppears': 'Posizione della barra degli strumenti',
    'fabric.editor.toolbarLabel': 'Editor',
    'fabric.editor.toolbarMediaTitle': "Aggiungi un'immagine, un video o un file",
    'fabric.editor.toolbarPositionFixedAtTop': 'Fissato in alto',
    'fabric.editor.toolbarPositionInline': 'In linea con il testo',
    'fabric.editor.tooltip.blockPanel': 'un pannello',
    'fabric.editor.tooltip.bulletList': 'un elenco',
    'fabric.editor.tooltip.decisionList': 'un elenco di decisioni',
    'fabric.editor.tooltip.defaultBlockNode': 'un nodo di blocco',
    'fabric.editor.tooltip.nestedExpand': "un'espansione annidata",
    'fabric.editor.tooltip.taskList': 'un elemento di azione',
    'fabric.editor.turnInto': 'Trasforma in',
    'fabric.editor.twoColumns': 'Layout a 2 colonne',
    'fabric.editor.typeAhead.popupLabel': 'Risultati del completamento automatico',
    'fabric.editor.typeAhead.quickInsertInputLabel': 'Inizia a digitare per cercare o filtrare le opzioni delle scelte rapide',
    'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Cerca',
    'fabric.editor.typeAhead.quickInsertPopupLabel': 'Scelte rapide per inserimenti e formattazione',
    'fabric.editor.typeahead.emojiInputLabel': 'Inizia a digitare per cercare o filtrare le opzioni delle emoji',
    'fabric.editor.typeahead.emojiListItemLabel': 'Emoji {name} Scelta rapida di testo {shortcut}',
    'fabric.editor.typeahead.emojiPopupLabel': 'Scelte rapide per emoji',
    'fabric.editor.typeahead.mentionInputLabel': 'Inizia a digitare per cercare gli utenti da taggare',
    'fabric.editor.typeahead.mentionPopupLabel': 'Utenti che puoi taggare',
    'fabric.editor.typeahead.metionListItemLabel': 'Utente {name} @{shortName}',
    'fabric.editor.unableToLoadContent': 'Impossibile caricare questo contenuto',
    'fabric.editor.unableToOpenLink': 'Impossibile aprire questo link',
    'fabric.editor.underline': 'Sottolineato',
    'fabric.editor.undo': 'Annulla',
    'fabric.editor.unknown.label': 'Sconosciuto',
    'fabric.editor.unlink': 'Rimuovi link',
    'fabric.editor.unorderedList': 'Elenco puntato',
    'fabric.editor.unorderedList.description': 'Crea un elenco non ordinato',
    'fabric.editor.unsupportedBlockContent': 'Questo editor non supporta la visualizzazione di questi contenuti',
    'fabric.editor.unsupportedContentTooltip': 'I contenuti non sono disponibili in questo editor; saranno preservati in fase di modifica e salvataggio',
    'fabric.editor.unsupportedInlineContent': 'Contenuti non supportati',
    'fabric.editor.upDown': "Utilizzando i tasti di direzione su e gi\xf9 nel seguente campo di inserimento verr\xe0 aggiornata la data sottostante",
    'fabric.editor.url': 'Visualizza URL',
    'fabric.editor.urlDescription': 'Visualizza il link come URL',
    'fabric.editor.urlTitle': 'URL',
    'fabric.editor.useMarkdown': 'Usa Markdown',
    'fabric.editor.viewAndAddCommentsOnMedia': 'Visualizza e aggiungi i commenti',
    'fabric.editor.viewCommentOnMedia': 'Visualizza i commenti',
    'fabric.editor.viewMore': 'Visualizza altro',
    'fabric.editor.viewMoreAriaLabel': 'Visualizza tutti gli elementi',
    'fabric.editor.visit': 'Apri il link in una nuova finestra',
    'fabric.editor.warning': 'Avviso',
    'fabric.editor.warningPanel': 'Pannello avvisi',
    'fabric.editor.warningPanel.description': 'Aggiungi un avviso in un pannello colorato',
    'fabric.editor.wrapLeft': 'Ritorno a capo a sinistra',
    'fabric.editor.wrapRight': 'RItorno a capo a destra',
    'fabric.emoji.label': 'Emoji',
    'fabric.theme.blue': 'Blu',
    'fabric.theme.bold-blue': 'Blu intenso',
    'fabric.theme.bold-gray': 'Grigio intenso',
    'fabric.theme.bold-green': 'Verde intenso',
    'fabric.theme.bold-magenta': 'Magenta molto intenso',
    'fabric.theme.bold-orange': 'Arancione intenso',
    'fabric.theme.bold-purple': 'Viola intenso',
    'fabric.theme.bold-red': 'Rosso intenso',
    'fabric.theme.bold-teal': 'Turchese intenso',
    'fabric.theme.bold-yellow': 'Giallo intenso',
    'fabric.theme.bolder-blue': 'Blu molto intenso',
    'fabric.theme.bolder-gray': 'Grigio molto intenso',
    'fabric.theme.bolder-green': 'Verde molto intenso',
    'fabric.theme.bolder-magenta': 'Magenta molto intenso',
    'fabric.theme.bolder-orange': 'Arancione molto intenso',
    'fabric.theme.bolder-purple': 'Viola molto intenso',
    'fabric.theme.bolder-red': 'Rosso molto intenso',
    'fabric.theme.bolder-teal': 'Turchese molto intenso',
    'fabric.theme.bolder-yellow': 'Giallo molto intenso',
    'fabric.theme.dark-blue': 'Blu scuro',
    'fabric.theme.dark-gray': 'Grigio scuro',
    'fabric.theme.dark-green': 'Verde scuro',
    'fabric.theme.dark-purple': 'Viola scuro',
    'fabric.theme.dark-red': 'Rosso scuro',
    'fabric.theme.dark-teal': 'Turchese scuro',
    'fabric.theme.dark-yellow': 'Giallo scuro',
    'fabric.theme.default': 'Predefinito',
    'fabric.theme.gray': 'Grigio',
    'fabric.theme.green': 'Verde',
    'fabric.theme.light-blue': 'Blu chiaro',
    'fabric.theme.light-gray': 'Grigio chiaro',
    'fabric.theme.light-green': 'Verde chiaro',
    'fabric.theme.light-purple': 'Viola chiaro',
    'fabric.theme.light-red': 'Rosso chiaro',
    'fabric.theme.light-teal': 'Turchese chiaro',
    'fabric.theme.light-yellow': 'Giallo chiaro',
    'fabric.theme.lime': 'Verde lime',
    'fabric.theme.magenta': 'Magenta',
    'fabric.theme.no-color': 'Nessuna evidenziazione',
    'fabric.theme.orange': 'Arancione',
    'fabric.theme.purple': 'Viola',
    'fabric.theme.red': 'Rosso',
    'fabric.theme.subtle-blue': 'Blu tenue',
    'fabric.theme.subtle-gray': 'Grigio tenue',
    'fabric.theme.subtle-green': 'Verde tenue',
    'fabric.theme.subtle-magenta': 'Magenta tenue',
    'fabric.theme.subtle-orange': 'Arancione tenue',
    'fabric.theme.subtle-purple': 'Viola tenue',
    'fabric.theme.subtle-red': 'Rosso tenue',
    'fabric.theme.subtle-teal': 'Turchese tenue',
    'fabric.theme.subtle-yellow': 'Giallo tenue',
    'fabric.theme.teal': 'Turchese',
    'fabric.theme.white': 'Bianco',
    'fabric.theme.yellow': 'Giallo',
    'fabrid.editor.rowNumbers': 'Numeri di riga',
    'rovo.agents.dropdown.title': 'Agenti',
    'rovo.agents.dropdown.viewAgents.label': 'Visualizza tutti gli agenti'
};

});


//# sourceMappingURL=it.42e6e4a7.js.map
